var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames, entityPluralLabel, entityTypeNameFor, toArray, titleCase, entityNormalizedField } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { Grid } from '../elements/grid';
import { mapValues, pickBy, map, uniqBy, get, size, find, flatten, sortBy, filter, intersection, includes, without, omit } from 'lodash';
import { EntitySelect } from '../entities/entity-select';
import { Card } from '../elements/card';
import { EntityFilterSelect } from './entity-filter-select';
import { sprintf } from 'sprintf-js';
import { useEntityTypeCards } from '../hooks/use-entity-type-cards';
import { EntityTypeTogglePill } from './entity-type-toggle-pill';
import { useEnv } from '../hooks/use-env';
import { EntityCard } from './entity-card';
import { useInfiniteScrollArray } from '../hooks/use-infinite-scroll-array';
import { GridLoader } from '../elements/grid-loader';
var cls = classNames('entity-grid');
export var EntityGridDefaultProps = {
  items: [],
  filterFieldNames: [],
  toggleTypes: [],
  filterValues: {},
  anyCardProps: {},
  filterFieldOptions: {},
  filterSpacing: 0,
  select: EntitySelect,
  onFilterValuesChange: function () {},
  desktopFullHdAutoColumns: 6,
  desktopLargeAutoColumns: 5,
  desktopAutoColumns: 4,
  tabletAutoColumns: 3,
  cardProps: {},
  itemsPerPage: 15
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CardStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FiltersStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    box-sizing: border-box;\n    flex-direction: column;\n    margin-top: ", ";\n    padding-bottom: ", ";\n\n    .shp--grid__item {\n      display: block;\n    };\n\n    "], ["\n    display: flex;\n    flex-grow: 1;\n    box-sizing: border-box;\n    flex-direction: column;\n    margin-top: ", ";\n    padding-bottom: ", ";\n\n    .shp--grid__item {\n      display: block;\n    };\n\n    "])), theme.UNIT(1), theme.UNIT(3)),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: row;\n    padding: 0 ", ";\n    \n  "], ["\n    flex-direction: row;\n    padding: 0 ", ";\n    \n  "])), theme.UNIT(3)),
  last: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (_a) {
    var maxContentWidth = _a.maxContentWidth;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      @media (min-width: ", ") {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    "], ["\n      @media (min-width: ", ") {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    "])), maxContentWidth || '1088px');
  }),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var filterSize = _a.filterSize;
    return filterSize === 'slim' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme.UNIT(filterSize === 'slim' ? 1 : 7));
  })
});
var FilterStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["  \n    ", "\n\n    flex-grow: 1;\n    flex-shrink: 0;\n    min-width: 150px;\n    box-sizing: border-box;\n    "], ["  \n    ", "\n\n    flex-grow: 1;\n    flex-shrink: 0;\n    min-width: 150px;\n    box-sizing: border-box;\n    "])), function (_a) {
    var filterSize = _a.filterSize;
    return filterSize === 'slim' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        padding: 0 ", ";\n      "], ["\n        padding: 0 ", ";\n      "])), theme.UNIT(3));
  }),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var FilterSelectStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SentryStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TogglesStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    flex-shrink: 1;\n    gap: ", ";\n    padding: 0 ", " ", " ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    flex-shrink: 1;\n    gap: ", ";\n    padding: 0 ", " ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(3), theme.UNIT(3), theme.UNIT(3)),
  desktop: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " 0;\n  \n  "], ["\n    padding: ", " 0;\n  \n  "])), theme.UNIT(3))
});
var ToggleStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    flex-shrink: 1;\n  "], ["\n    flex-shrink: 1;\n  "])))
});
var ids = function (items) {
  if (items === void 0) {
    items = [];
  }
  return items.map(function (item) {
    return item.id || item.value;
  });
};
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: styled(GridLoader)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SentryStyles),
  Filters: styled(Grid)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), FiltersStyles),
  Filter: styled.div.attrs(cls.attr('filter'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), FilterStyles),
  FilterSelect: styled(EntityFilterSelect)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), FilterSelectStyles),
  Toggles: styled.div.attrs(cls.attr('toggles'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TogglesStyles),
  Toggle: styled(EntityTypeTogglePill)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  Grid: styled(Grid)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Card: styled(Card)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), CardStyles)
};
export var EntityGrid = function (props) {
  var className = props.className,
    filterValues = props.filterValues,
    anyCardProps = props.anyCardProps,
    itemsPerPage = props.itemsPerPage,
    filterFieldNames = props.filterFieldNames,
    onFilterValuesChange = props.onFilterValuesChange,
    descriptionMaxLines = props.descriptionMaxLines,
    filterSize = props.filterSize,
    filterSpacing = props.filterSpacing,
    toggleTypes = props.toggleTypes,
    cardProps = props.cardProps,
    rest = __rest(props, ["className", "filterValues", "anyCardProps", "itemsPerPage", "filterFieldNames", "onFilterValuesChange", "descriptionMaxLines", "filterSize", "filterSpacing", "toggleTypes", "cardProps"]);
  var env = useEnv();
  var _a = __read(useState([]), 2),
    selectedTypes = _a[0],
    setSelectedTypes = _a[1];
  var hasFilters = !!filterFieldNames.length;
  var hasToggles = !!toggleTypes.length;
  var gridProps = omit(rest, ['items']);
  var filterItems = useMemo(function () {
    return pickBy(filterFieldNames.reduce(function (acc, fieldName) {
      var selectedItems = hasToggles && !!selectedTypes.length ? filter(props.items, function (item) {
        return includes(selectedTypes, entityTypeNameFor(item));
      }) : props.items;
      acc[fieldName] = sortBy(uniqBy(flatten(selectedItems.map(function (item) {
        return item[fieldName] || [];
      })), 'id'), entityNormalizedField("name"));
      return acc;
    }, {}), function (filterItem) {
      return filterItem && filterItem.length;
    });
  }, [props.items, selectedTypes]);
  var filterFieldOptions = __assign(__assign({}, props.filterFieldOptions), mapValues(filterItems, function (filterItem, key) {
    var knownEntityTypeName = filterItem.length && filterItem[0].__typename;
    var entityTypeName = knownEntityTypeName || 'Entity';
    var placeholder = sprintf("(All %s)", knownEntityTypeName ? entityPluralLabel(filterItem.length && filterItem[0]) : titleCase(key));
    return {
      placeholder: placeholder,
      entityTypeName: entityTypeName
    };
  }));
  var filterValueIds = mapValues(filterValues, function (item) {
    return ids(item || []);
  });
  var matchingItems = hasFilters ? filter(props.items, function (item) {
    return size(filterValues) === 0 || find(filterValueIds, function (idSet, fieldName) {
      return !!intersection(ids(toArray(item[fieldName])), idSet).length;
    });
  }) : props.items;
  var finalItems = hasToggles && selectedTypes.length ? filter(matchingItems, function (item) {
    return includes(selectedTypes, entityTypeNameFor(item));
  }) : matchingItems;
  var _b = useInfiniteScrollArray({
      all: finalItems,
      itemsPerPage: itemsPerPage
    }),
    items = _b.items,
    sentryRef = _b.sentryRef,
    hasNextPage = _b.hasNextPage;
  var onSelectChange = function (fieldName) {
    return function (value) {
      var _a;
      var newValue = __spreadArray([], __read(value || []), false);
      var newFilters = pickBy(__assign(__assign({}, filterValues), (_a = {}, _a[fieldName] = !!newValue.length && newValue, _a)));
      onFilterValuesChange(newFilters);
    };
  };
  var ENTITY_CARD_COMPONENTS = useEntityTypeCards();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasToggles && React.createElement(My.Toggles, null, toggleTypes.map(function (type) {
    var isOn = includes(selectedTypes, type.name);
    return React.createElement(My.Toggle, {
      key: type.name,
      label: type.label,
      entityTypeName: type.name,
      isOn: isOn,
      onClick: function () {
        var newSelectedTypes = isOn ? without(selectedTypes, type.name) : __spreadArray([type.name], __read(selectedTypes), false);
        setSelectedTypes(newSelectedTypes);
      }
    });
  })), hasFilters && React.createElement(My.Filters, {
    maxContentWidth: env.MAX_WIDTH_CONTENT,
    filterSize: filterSize,
    landscapeAutoColumns: 1,
    maxColumns: size(filterItems),
    spacing: filterSpacing,
    items: map(filterItems, function (filterItem, fieldName) {
      return React.createElement(My.Filter, {
        key: "filter-".concat(fieldName),
        filterSize: filterSize
      }, React.createElement(My.FilterSelect, {
        isMulti: true,
        size: filterSize,
        value: filterValues[fieldName] || [],
        onChange: onSelectChange(fieldName),
        placeholder: get(filterFieldOptions, "".concat(fieldName, ".placeholder"), 'Select'),
        entityTypeName: get(filterFieldOptions, "".concat(fieldName, ".placeholder"), 'Entity'),
        items: filterItem
      }));
    })
  }), React.createElement(My.Grid, __assign({}, gridProps, {
    items: items.map(function (item, index) {
      var Card = props.card || ENTITY_CARD_COMPONENTS[entityTypeNameFor(item)] || EntityCard;
      return React.createElement(Card, __assign({
        animate: true,
        index: index / (finalItems.length / 16),
        key: item.id
      }, cardProps, anyCardProps, {
        descriptionMaxLines: descriptionMaxLines,
        entity: item
      }));
    })
  })), hasNextPage && React.createElement(My.Loader, {
    ref: sentryRef
  }));
};
EntityGrid.defaultProps = EntityGridDefaultProps;
EntityGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;